import {Component, OnInit} from '@angular/core';
import {EventMessagesService} from "@store/event-messages.service";

@Component({
  selector: 'app-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.scss']
})
export class EventsComponent implements OnInit {

  constructor(
    public eventMessagesService: EventMessagesService,
  ) {
  }

  ngOnInit(): void {
  }

}
